<template>
  <div class="home">
    <b-container class="marginal">
      <h2>Aide</h2>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'aide',
  components: {

  }
}
</script>